import { Badge } from '@progress/kendo-react-indicators'
import classNames from 'classnames'
import React from 'react'

import styles from './FlickeringBadge.css'

export type FlickeringBadgeProps = {
  color?: 'error' | 'primary'
  'data-testid'?: string
}

export const FlickeringBadge = ({
  color = 'primary',
  'data-testid': dataTestId = 'components-elements-flickering-badge',
}: FlickeringBadgeProps) => (
  <Badge
    className={classNames(styles.root, styles[color])}
    data-testid={dataTestId}
    rounded="full"
    themeColor={color}
  />
)
